
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthGuard, ConfigModule, FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { KbDocSearchPageComponent } from './kb-doc-search-page/kb-doc-search-page.component';
import { RouterModule } from '@angular/router';
import { AtMessageModule, CmsPageGuard, IconModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, PageComponentModule, PageLayoutComponent, ProductListModule, SpinnerModule, StarRatingModule } from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { KbDocumentGridItemModule } from '../kb-product-list/kb-document-grid/kb-document-grid.module';
import { KbDocumentListItemModule } from '../kb-product-list/kb-document-list/kb-document-list.module';
import { FacetNavigationModule } from '../facet-navigation/facet-navigation.module';
import { FavouritesListingPageComponent } from './favourites-listing-page/favourites-listing-page.component';
import { KbMyAccountLeftSideNavModule } from '../kb-myAccount/my-account-left-sidenav/my-account-left-sidenav.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPaginationModule } from '../kb-pagination/kb-pagination/kb-pagination.module';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        ReactiveFormsModule,
        AtMessageModule,
        FeaturesConfigModule,
        IconModule,
        InfiniteScrollModule,
        ItemCounterModule,
        ListNavigationModule,
        MediaModule,
        OutletModule,
        PageComponentModule,
        RouterModule,
        SpinnerModule,
        StarRatingModule,
        UrlModule,
        ProductListModule,
        KbDocumentGridItemModule,
        KbDocumentListItemModule,
        FacetNavigationModule,
        KbMyAccountLeftSideNavModule,
        KbPaginationModule,
        RouterModule.forChild([
            {
                path: 'documentLibrary/kbdocument',
                data: { pageLabel: '/documentLibrary' },
                component: PageLayoutComponent,
                canActivate: [CmsPageGuard],
              },
          ]),
        ConfigModule.withConfig({
            cmsComponents: {
                DocumentLibraryFlexComponent: {
                    component: KbDocSearchPageComponent,
                    guards: [SecureGuard]
                },
                MyFavoriteFlexComponent: {
                    component: FavouritesListingPageComponent,
                    guards: [SecureGuard, AuthGuard]
                }
            }
        })
    ],
    declarations: [KbDocSearchPageComponent, FavouritesListingPageComponent],
})
export class KbCustomDocumentSearchModule { }
